import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelText as _vModelText } from "vue";
const _hoisted_1 = { class: "h-100 py-4 px-3" };
const _hoisted_2 = {
    class: "container flex-grow-1",
    style: { "max-width": "1000px" }
};
const _hoisted_3 = { class: "row mb-4 animate__animated animate__fadeIn" };
const _hoisted_4 = { class: "col-12 text-center" };
const _hoisted_5 = {
    class: "card bg-gradient-primary text-white border-0 shadow-sm overflow-hidden",
    style: { "border-radius": "20px" }
};
const _hoisted_6 = { class: "card-body p-4 position-relative" };
const _hoisted_7 = { class: "d-flex flex-column align-items-center" };
const _hoisted_8 = { class: "fw-bold mb-1 text-white" };
const _hoisted_9 = { class: "mb-0 opacity-75" };
const _hoisted_10 = { class: "row g-4 justify-content-center animate__animated animate__fadeInUp" };
const _hoisted_11 = { class: "col-lg-6" };
const _hoisted_12 = {
    class: "card border-0 shadow-sm h-100",
    style: { "border-radius": "20px" }
};
const _hoisted_13 = { class: "card-body p-4 d-flex flex-column h-100" };
const _hoisted_14 = { class: "d-flex align-items-center mb-4" };
const _hoisted_15 = { class: "fw-bold mb-0" };
const _hoisted_16 = { class: "mb-4" };
const _hoisted_17 = { class: "form-label fw-medium" };
const _hoisted_18 = { class: "input-group" };
const _hoisted_19 = ["type", "placeholder"];
const _hoisted_20 = { class: "d-flex align-items-center justify-content-between mb-4" };
const _hoisted_21 = { class: "d-block fw-medium" };
const _hoisted_22 = { class: "d-block fw-medium text-end" };
const _hoisted_23 = { class: "text-muted small" };
const _hoisted_24 = { class: "mt-auto pt-3" };
const _hoisted_25 = ["disabled"];
const _hoisted_26 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_27 = {
    key: 1,
    class: "flaticon-save me-2"
};
const _hoisted_28 = ["disabled"];
const _hoisted_29 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_30 = {
    key: 1,
    class: "flaticon-refresh me-2"
};
const _hoisted_31 = { class: "col-lg-6" };
const _hoisted_32 = {
    class: "card border-0 shadow-sm h-100",
    style: { "border-radius": "20px" }
};
const _hoisted_33 = { class: "card-body p-4 d-flex flex-column h-100" };
const _hoisted_34 = { class: "d-flex align-items-center mb-4" };
const _hoisted_35 = { class: "fw-bold mb-0" };
const _hoisted_36 = {
    key: 0,
    class: "mb-4"
};
const _hoisted_37 = { class: "form-label small fw-medium" };
const _hoisted_38 = { value: null };
const _hoisted_39 = ["value"];
const _hoisted_40 = { class: "row g-3 mb-4" };
const _hoisted_41 = { class: "col-md-6" };
const _hoisted_42 = { class: "form-label small fw-medium" };
const _hoisted_43 = { class: "col-md-6" };
const _hoisted_44 = { class: "form-label small fw-medium" };
const _hoisted_45 = { class: "text-muted small mb-4" };
const _hoisted_46 = {
    class: "alert bg-info-subtle border-0 mb-4",
    style: { "border-radius": "12px" }
};
const _hoisted_47 = { class: "d-flex" };
const _hoisted_48 = { class: "small text-info-emphasis" };
const _hoisted_49 = {
    key: 1,
    class: "mb-4"
};
const _hoisted_50 = { class: "mt-auto pt-2" };
const _hoisted_51 = ["disabled"];
const _hoisted_52 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_53 = {
    key: 1,
    class: "flaticon-share-1 me-2"
};
const _hoisted_54 = {
    key: 1,
    class: "modal fade show d-block",
    tabindex: "-1",
    role: "dialog"
};
const _hoisted_55 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const _hoisted_56 = {
    class: "modal-content border-0 shadow-lg",
    style: { "border-radius": "24px", "overflow": "hidden" }
};
const _hoisted_57 = { class: "modal-header border-0 p-4 pb-0" };
const _hoisted_58 = { class: "modal-title fw-bold fs-4" };
const _hoisted_59 = { class: "modal-body p-4" };
const _hoisted_60 = {
    class: "bg-info-subtle p-4 mb-4",
    style: { "border-radius": "16px" }
};
const _hoisted_61 = { class: "d-flex align-items-center" };
const _hoisted_62 = { class: "ms-3" };
const _hoisted_63 = { class: "mb-0 fw-bold text-dark" };
const _hoisted_64 = {
    class: "text-secondary mb-0 px-2",
    style: { "font-size": "1.05rem", "line-height": "1.6" }
};
const _hoisted_65 = { class: "modal-footer border-0 p-4 pt-0 g-3" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "bg-white bg-opacity-25 p-3 rounded-circle mb-3" }, [
                                    _createElementVNode("i", { class: "flaticon-rocket fs-1" })
                                ], -1)),
                                _createElementVNode("div", null, [
                                    _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t('omnesightAi.title')), 1),
                                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('omnesightAi.subtitle')), 1)
                                ])
                            ])
                        ])
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                _cache[13] || (_cache[13] = _createElementVNode("i", { class: "flaticon-settings me-2 text-primary fs-4" }, null, -1)),
                                _createElementVNode("h5", _hoisted_15, _toDisplayString(_ctx.$t('omnesightAi.config')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('omnesightAi.apiKey')), 1),
                                _createElementVNode("div", _hoisted_18, [
                                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "input-group-text bg-light border-0" }, [
                                        _createElementVNode("i", { class: "flaticon-key" })
                                    ], -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.config.apiKey) = $event)),
                                        type: _ctx.showApiKey ? 'text' : 'password',
                                        class: "form-control bg-light border-0",
                                        placeholder: _ctx.$t('omnesightAi.apiKeyPlaceholder')
                                    }, null, 8, _hoisted_19), [
                                        [_vModelDynamic, _ctx.config.apiKey]
                                    ]),
                                    _createElementVNode("button", {
                                        class: "btn btn-light border-0",
                                        type: "button",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.showApiKey = !_ctx.showApiKey)),
                                        title: "Afficher/Masquer"
                                    }, [
                                        _createElementVNode("i", {
                                            class: _normalizeClass(_ctx.showApiKey ? 'flaticon-visibility-off' : 'flaticon-eye')
                                        }, null, 2)
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('omnesightAi.status')), 1),
                                    _createElementVNode("span", {
                                        class: _normalizeClass(["badge rounded-pill mt-1", _ctx.config.isActive ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'])
                                    }, _toDisplayString(_ctx.config.isActive ? _ctx.$t('omnesightAi.active') : _ctx.$t('omnesightAi.inactive')), 3)
                                ]),
                                _createElementVNode("div", null, [
                                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('omnesightAi.lastSync')), 1),
                                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.config.lastSyncAt ? _ctx.formatDate(_ctx.config.lastSyncAt) : _ctx.$t('omnesightAi.never')), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("button", {
                                    onClick: _cache[2] || (_cache[2] =
                                        //@ts-ignore
                                        (...args) => (_ctx.saveConfig && _ctx.saveConfig(...args))),
                                    class: "btn btn-primary w-100 py-3 d-flex align-items-center justify-content-center",
                                    disabled: _ctx.saving,
                                    style: { "border-radius": "12px" }
                                }, [
                                    (_ctx.saving)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_26))
                                        : (_openBlock(), _createElementBlock("i", _hoisted_27)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('omnesightAi.saveConfig')), 1)
                                ], 8, _hoisted_25),
                                _createElementVNode("button", {
                                    onClick: _cache[3] || (_cache[3] =
                                        //@ts-ignore
                                        (...args) => (_ctx.testConnection && _ctx.testConnection(...args))),
                                    class: "btn btn-outline-primary w-100 py-3 d-flex align-items-center justify-content-center mt-2",
                                    disabled: _ctx.testing || !_ctx.config.apiKey,
                                    style: { "border-radius": "12px", "border-style": "dashed" }
                                }, [
                                    (_ctx.testing)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_29))
                                        : (_openBlock(), _createElementBlock("i", _hoisted_30)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('omnesightAi.testConnection') || 'Tester la connexion'), 1)
                                ], 8, _hoisted_28)
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                                _cache[15] || (_cache[15] = _createElementVNode("i", { class: "flaticon-cloud-computing me-2 text-info fs-4" }, null, -1)),
                                _createElementVNode("h5", _hoisted_35, _toDisplayString(_ctx.$t('omnesightAi.historyPush')), 1)
                            ]),
                            (_ctx.restaurants.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                    _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('omnesightAi.selectRestaurant') || 'Sélectionner un restaurant'), 1),
                                    _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.selectedRestaurantId) = $event)),
                                        class: "form-select bg-light border-0",
                                        style: { "border-radius": "8px" }
                                    }, [
                                        _createElementVNode("option", _hoisted_38, _toDisplayString(_ctx.$t('omnesightAi.allRestaurants') || 'Tous les restaurants'), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restaurants, (res) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: res.id,
                                                value: res.id
                                            }, _toDisplayString(res.name), 9, _hoisted_39));
                                        }), 128))
                                    ], 512), [
                                        [_vModelSelect, _ctx.selectedRestaurantId]
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t('omnesightAi.startDate')), 1),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "date",
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.startDate) = $event)),
                                        class: "form-control bg-light border-0",
                                        style: { "border-radius": "8px" }
                                    }, null, 512), [
                                        [_vModelText, _ctx.startDate]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_43, [
                                    _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('omnesightAi.endDate')), 1),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "date",
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.endDate) = $event)),
                                        class: "form-control bg-light border-0",
                                        style: { "border-radius": "8px" }
                                    }, null, 512), [
                                        [_vModelText, _ctx.endDate]
                                    ])
                                ])
                            ]),
                            _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.$t('omnesightAi.pushDescription')), 1),
                            _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("div", _hoisted_47, [
                                    _cache[16] || (_cache[16] = _createElementVNode("i", { class: "flaticon-info me-2 text-info fs-5" }, null, -1)),
                                    _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t('omnesightAi.pushConfirm')), 1)
                                ])
                            ]),
                            (_ctx.pushProgress)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [...(_cache[17] || (_cache[17] = [
                                        _createElementVNode("div", {
                                            class: "progress mb-2",
                                            style: { "height": "8px", "border-radius": "4px" }
                                        }, [
                                            _createElementVNode("div", {
                                                class: "progress-bar progress-bar-striped progress-bar-animated bg-info",
                                                role: "progressbar",
                                                style: { width: '100%' }
                                            })
                                        ], -1),
                                        _createElementVNode("span", { class: "text-muted small" }, "Synchronisation en cours...", -1)
                                    ]))]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_50, [
                                _createElementVNode("button", {
                                    onClick: _cache[7] || (_cache[7] =
                                        //@ts-ignore
                                        (...args) => (_ctx.confirmPush && _ctx.confirmPush(...args))),
                                    class: "btn btn-info text-white w-100 py-3 d-flex align-items-center justify-content-center",
                                    disabled: _ctx.pushing || !_ctx.config.apiKey,
                                    style: { "border-radius": "12px" }
                                }, [
                                    (_ctx.pushing)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_52))
                                        : (_openBlock(), _createElementBlock("i", _hoisted_53)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('omnesightAi.pushButton')), 1)
                                ], 8, _hoisted_51)
                            ])
                        ])
                    ])
                ])
            ])
        ]),
        (_ctx.showPushModal)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "modal-backdrop fade show",
                onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.showPushModal = false))
            }))
            : _createCommentVNode("", true),
        (_ctx.showPushModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("h5", _hoisted_58, _toDisplayString(_ctx.$t('omnesightAi.historyPush')), 1),
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn-close shadow-none",
                                onClick: _cache[9] || (_cache[9] = ($event) => (_ctx.showPushModal = false)),
                                "aria-label": "Close"
                            })
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                            _createElementVNode("div", _hoisted_60, [
                                _createElementVNode("div", _hoisted_61, [
                                    _cache[19] || (_cache[19] = _createElementVNode("div", {
                                        class: "flex-shrink-0 bg-info rounded-circle d-flex align-items-center justify-content-center",
                                        style: { "width": "48px", "height": "48px" }
                                    }, [
                                        _createElementVNode("i", { class: "flaticon-cloud-computing text-white fs-4" })
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_62, [
                                        _createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.$t('common.confirmation') || 'Confirmation'), 1),
                                        _cache[18] || (_cache[18] = _createElementVNode("p", { class: "mb-0 text-info-emphasis small opacity-75" }, "Omnesight AI Integration", -1))
                                    ])
                                ])
                            ]),
                            _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.$t('omnesightAi.pushConfirm')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-light border-0 flex-grow-1 py-3 fw-bold",
                                onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.showPushModal = false)),
                                style: { "border-radius": "14px", "color": "#64748b", "background-color": "#f1f5f9" }
                            }, _toDisplayString(_ctx.$t('common.cancel') || 'Annuler'), 1),
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-info text-white flex-grow-1 py-3 fw-bold shadow-sm",
                                onClick: _cache[11] || (_cache[11] =
                                    //@ts-ignore
                                    (...args) => (_ctx.executePush && _ctx.executePush(...args))),
                                style: { "border-radius": "14px" }
                            }, _toDisplayString(_ctx.$t('omnesightAi.pushButton')), 1)
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("", true)
    ]));
}
